const notify = (level, defaultMessage, message) => {
  const normalizedMessage = message || defaultMessage;
  const consoleMethod = level === 'error' ? 'error' : 'log';

  // Keep diagnostics available even when no visual toast provider is mounted.
  console[consoleMethod](`[${level.toUpperCase()}] ${normalizedMessage}`);

  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(
    new CustomEvent('passiveguard:toast', {
      detail: {
        level,
        message: normalizedMessage,
      },
    })
  );
};

export const toast = {
  error: (message) => notify('error', 'An error occurred', message),
  success: (message) => notify('success', 'Success', message),
};

export default toast;
